import React from 'react'

import { IconProps } from './types'

const InformationCircleSolid: React.FC<IconProps> = ({
  color,
  size,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill={color}
    {...rest}
  >
    <path
      fillRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
      clipRule="evenodd"
    />
  </svg>
)

InformationCircleSolid.displayName = 'InformationCircleSolid'
InformationCircleSolid.defaultProps = {
  size: 20,
  color: 'currentColor',
}

export default InformationCircleSolid
